import ClearIcon from '@mui/icons-material/Clear';
import EmailIcon from '@mui/icons-material/Email';
import {
  AppBar,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useState } from 'react';

const useStyles = makeStyles(theme => ({
  header: {
    top: '85px', // 85
    background: '#fff',
    zIndex: 998,
    borderBottom: '1px solid #dcdcdc',
    borderTop: '1px solid #dcdcdc',
    [theme.breakpoints.down('md')]: {
      top: '120px',
    },
  },
  emailAddress: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 600,
  },
  formElement: {
    width: '100%',
  },
}));

const EmailOverview = () => {
  const classes = useStyles();

  const EmailList = [
    {
      id: 0,
      event: 'Accepted',
      category: 'AlertLowered',
      to: 'brogers@anthology.com',
      subject: 'New Beacon Update: Chris Husser',
      sentDate: new Date('06/18/2021'),
    },
    {
      id: 1,
      event: 'Rejected',
      category: 'MailingGroup',
      to: 'cleone@anthology.com',
      subject: 'New Beacon Mail',
      sentDate: new Date('06/18/2021'),
    },
    {
      id: 2,
      event: 'Accepted',
      category: 'MailingGroup',
      to: 'asmith@anthology.com',
      subject: 'New Beacon Update: Chris Husser',
      sentDate: new Date('06/18/2021'),
    },
    {
      id: 3,
      event: 'Accepted',
      category: 'AlertLowered',
      to: 'jdoe@anthology.com',
      subject: 'New Beacon Update: Chris Husser',
      sentDate: new Date('06/18/2021'),
    },
    {
      id: 4,
      event: 'Accepted',
      category: 'IndividualNotification',
      to: 'dwilliams@anthology.com',
      subject: 'New Beacon Update: Chris Husser',
      sentDate: new Date('06/18/2021'),
    },
  ];
  //  as {
  //   event: String;
  //   category: String;
  //   to: String;
  //   subject: String;
  //   sentDate: Date;
  // };

  const [isSearching, setIsSearching] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [statusValue, setStatusValue] = useState('');
  const [categoryValue, setCategoryValue] = useState('');
  return (
    <>
      <Box display="flex">
        <Box flexGrow={1}>
          <Typography variant="h1">Email Overview</Typography>
        </Box>
      </Box>

      <Grid container spacing={4}>
        <Grid item xs={4}>
          <Paper elevation={2} square style={{ padding: '5px 10px' }}>
            <div style={{ margin: '10px 0' }}>
              <FormControl variant="outlined" className={classes.formElement}>
                <TextField
                  variant="outlined"
                  label="Search Recipients"
                  onChange={x => {
                    setIsSearching(true), setSearchValue(x.target.value);
                  }}
                  value={searchValue}
                  InputLabelProps={{ id: 'search-email' }}
                  inputProps={{ 'aria-labelledby': 'search-email' }}
                  InputProps={{
                    endAdornment: isSearching && (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={() => {
                            setIsSearching(false);
                            setSearchValue('');
                          }}
                          size="large"
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              </FormControl>
            </div>
            <div style={{ margin: '10px 0' }}>
              <FormControl variant="outlined" className={classes.formElement}>
                <InputLabel id="search-recipient">Status</InputLabel>
                <Select
                  value={statusValue}
                  onChange={e => {
                    setStatusValue(e.target.value as string);
                  }}
                >
                  <MenuItem>
                    <ListItemText primary="Accepted" />
                  </MenuItem>
                  <MenuItem>
                    <ListItemText primary="Rejected" />
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
            <div style={{ margin: '10px 0' }}>
              <FormControl variant="outlined" className={classes.formElement}>
                <InputLabel id="search-recipient">Category</InputLabel>
                <Select
                  value={categoryValue}
                  onChange={e => {
                    setCategoryValue(e.target.value as string);
                  }}
                >
                  <MenuItem>
                    <ListItemText primary="Alert Lowered" />
                  </MenuItem>
                  <MenuItem>
                    <ListItemText primary="Individual Notification" />
                  </MenuItem>
                  <MenuItem>
                    <ListItemText primary="Mailing Group" />
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
            <div style={{ margin: '10px 0' }}>
              <Button
                style={{ width: '100%' }}
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsSearching(false);
                  setSearchValue('');
                }}
              >
                <Typography>Reset Filters</Typography>
              </Button>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={8}>
          <Paper>
            <AppBar position="sticky" elevation={0} className={classes.header}>
              <Toolbar variant="dense" style={{ padding: '0 0 0 30px' }}>
                <Box display="flex" style={{ width: '100%' }}>
                  <Box flexGrow={1} />
                  <Box style={{ marginRight: '20px' }}>
                    <Typography variant="body1" style={{ color: '#000000' }}>
                      Showing 1 - 5 of {EmailList.length}
                    </Typography>
                  </Box>
                </Box>
              </Toolbar>
            </AppBar>
            <List>
              {EmailList.map(x => (
                <li style={{ borderBottom: '1px solid #dcdcdc' }} key={x.id}>
                  <ListItem component="div" alignItems="flex-start">
                    <ListItemIcon>
                      <EmailIcon />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography
                          variant="h3"
                          className={classes.emailAddress}
                        >
                          {x.to}
                        </Typography>
                      }
                      secondary={
                        <div>
                          <Typography variant="caption">
                            <strong>Subject: </strong>
                            {x.subject}
                          </Typography>
                        </div>
                      }
                    />
                  </ListItem>
                  <Box
                    display="flex"
                    flexDirection="row"
                    p={0}
                    style={{ marginLeft: '72px', marginBottom: '20px' }}
                  >
                    <Box>
                      <div>
                        <Typography variant="caption">
                          <strong>Status: </strong>
                          {x.event}
                        </Typography>
                      </div>
                      <div>
                        <Typography variant="caption">
                          <strong>Category: </strong>
                          {x.category}
                        </Typography>
                      </div>
                    </Box>
                  </Box>
                </li>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default EmailOverview;
